module Life.Game.Patterns
  ( acorn
  , bHeptomino
  , buckaroo
  , collision
  , copperhead
  , eater
  , flower
  , galaxy
  , glider
  , gliderGun
  , gliderSeNw
  , headphones
  , heart
  , octocat
  , piHeptomino
  , pufferFish
  , pufferFishSpaceship
  , pulsar
  , rPentomino
  , rabbits
  , shipsPassing
  , sky
  , spaceship
  )
  where

import Prelude

import Data.Tuple.Nested ((/\))
import Life.Types.Grid.Cell (Cell)
import Life.Types.Grid.Cell as C

rabbits :: Array Cell
rabbits = C.fromAscii
  """
    . . # . . . . #
    # # . . . . . .
    . # # . # # # .
  """

glider :: Array Cell
glider = C.fromAscii
  """
    . . #
    # . #
    . # #
  """

gliderSeNw :: Array Cell
gliderSeNw = C.fromAscii
  """
    # # .
    # . #
    # . .
  """

collision :: Array Cell
collision =
  glider <> C.adjust (11 /\ 11) gliderSeNw

rPentomino :: Array Cell
rPentomino = C.fromAscii
  """
    . # #
    # # .
    . # .
  """

acorn :: Array Cell
acorn = C.fromAscii
  """
    . # . . . . .
    . . . # . . .
    # # . . # # #
  """

piHeptomino :: Array Cell
piHeptomino = C.fromAscii
  """
    # # #
    # . #
    # . #
  """

bHeptomino :: Array Cell
bHeptomino = C.fromAscii
  """
    # . # #
    # # # .
    . # . .
  """

copperhead :: Array Cell
copperhead = C.fromAscii
  """
    . . . . # # . . . .
    . . . # # # # . . .
    . . . . . . . . . .
    . . # # # # # # . .
    . . . # # # # . . .
    . . . . . . . . . .
    . . # # . . # # . .
    # # . # . . # . # #
    . . . # . . # . . .
    . . . . . . . . . .
    . . . . . . . . . .
    . . . . # # . . . .
    . . . . # # . . . .
  """

galaxy :: Array Cell
galaxy = C.fromAscii
  """
    . . . . . # # # # . .
    . # # . # . . . . # .
    # . . . # . . . . # .
    # . . . . # # . . . .
    # . . # . . . . # # .
    # . . # . . . # . . #
    . # # . . . . # . . #
    . . . . # # . . . . #
    . # . . . . # . . . #
    . # . . . . # . # # .
    . . # # # # . . . . .
  """

sky :: Array Cell
sky = C.fromAscii
  """
    . . . . . . . . . # # . . . . .
    . . . # # # . . # . . # . . . .
    . . # # # . . . . # # . . . . .
    . . . . . . . . . . . . . # # .
    . . . . . . . . . . . . # . . #
    . . . . . . . . . . . . . # # .
    . . . . . # # . . . . . . . . .
    . . . . # . . # . . . . . . . .
    . . . . . # # . . . . . . . . .
    . # # . . . . . . . . # # # . .
    # . . # . . . . . . # # # . . .
    . # # . . . . . . . . . . . . .
  """

flower :: Array Cell
flower = C.fromAscii
  """
    . . . . . . # . . . . . .
    . . . . . # . # . . . . .
    . . . . . # . # . . . . .
    . . . . . . # . . . . . .
    . . . . . . . . . . . . .
    . # # . . . # . . . # # .
    # . . # . # # # . # . . #
    . # # . . . # . . . # # .
    . . . . . . . . . . . . .
    . . . . . . # . . . . . .
    . . . . . # . # . . . . .
    . . . . . # . # . . . . .
    . . . . . . # . . . . . .
  """

eater :: Array Cell
eater = C.fromAscii
  """
    # # . .
    # . . .
    . # # #
    . . . #
  """

spaceship :: Array Cell
spaceship = C.fromAscii
  """
    # . . # .
    . . . . #
    # . . . #
    . # # # #
  """

shipsPassing :: Array Cell
shipsPassing = C.fromAscii
  """
    # . . # . . . . . . . . . . . .
    . . . . # . . . . . . . . . . .
    # . . . # . . . . . . . . . . .
    . # # # # . . . . . . . . . . .
    . . . . . . . . . . . . . . . .
    . . . . . . . . . . . . . . . .
    . . . . . . . . . . . . . . . .
    . . . . . . . . . . . . . . . .
    . . . . . . . . . . . . . . . .
    . . . . . . . . . . . . . . . .
    . . . . . . . . . . . . . . . .
    . . . . . . . . . . . . . . . .
    . . . . . . . . . . . # # # # .
    . . . . . . . . . . . # . . . #
    . . . . . . . . . . . # . . . .
    . . . . . . . . . . . . # . . #
  """

pulsar :: Array Cell
pulsar = C.fromAscii
  """
    . . # # . . . . . # # . .
    . . . # # . . . # # . . .
    # . . # . # . # . # . . #
    # # # . # # . # # . # # #
    . # . # . # . # . # . # .
    . . # # # . . . # # # . .
    . . . . . . . . . . . . .
    . . # # # . . . # # # . .
    . # . # . # . # . # . # .
    # # # . # # . # # . # # #
    # . . # . # . # . # . . #
    . . . # # . . . # # . . .
    . . # # . . . . . # # . .
  """

heart :: Array Cell
heart = C.fromAscii
  """
    . . # # # . . . # # # . .
    . # . . . # . # . . . # .
    # . . . . . # . . . . . #
    # . . . . . . . . . . . #
    # # . . . . . . . . . . #
    . # # . . . . . . . . # .
    . . # # . . . . . . # . .
    . . . # # . . . . # . . .
    . . . . # # . . # . . . .
    . . . . . # # # . . . . .
    . . . . . . # . . . . . .
  """

headphones :: Array Cell
headphones = C.fromAscii
  """
    . . . . . # # # # # # . . . . .
    . . . . # # # # # # # # . . . .
    . . . # # . . . . . . # # . . .
    . . . # . . . . . . . . # . . .
    . . . # . . . . . # # . # . . .
    . . . # . . . . # . # . # . . .
    . # # # . . . . . # . . # # # .
    # . . # . # . # . . . . # . . #
    # . . # . # # . . # . . # . . #
    # . . # . . # . # . # . # . . #
    . # # # . . . . # . # . # # # .
    . . . . . . . . . # . . . . . .
  """

octocat :: Array Cell
octocat = C.fromAscii
  """
    . . # # . . . # # .
    . . # . # # # . # .
    . # . . . . . . . #
    . # . . . . . . . #
    . # . . . . . . . #
    . . # . . . . . # .
    # . . # . . . # . .
    . # # . # . # . . .
    . . . # . . . # . .
    . . . # . . . # . .
  """

gliderGun :: Array Cell
gliderGun = C.fromAscii
  """
    . . . . . . . . . . . . . . . . . . . . . . . . # . . . . . . . . . . .
    . . . . . . . . . . . . . . . . . . . . . . # . # . . . . . . . . . . .
    . . . . . . . . . . . . # # . . . . . . # # . . . . . . . . . . . . # #
    . . . . . . . . . . . # . . . # . . . . # # . . . . . . . . . . . . # #
    # # . . . . . . . . # . . . . . # . . . # # . . . . . . . . . . . . . .
    # # . . . . . . . . # . . . # . # # . . . . # . # . . . . . . . . . . .
    . . . . . . . . . . # . . . . . # . . . . . . . # . . . . . . . . . . .
    . . . . . . . . . . . # . . . # . . . . . . . . . . . . . . . . . . . .
    . . . . . . . . . . . . # # . . . . . . . . . . . . . . . . . . . . . .
  """

buckaroo :: Array Cell
buckaroo = C.fromAscii
  """
    . . . . . . . . . . . . # # . . . . . . . .
    . . . . . . . . . . . # . . . # . . . . . .
    . . . . . . . . . . # . . . . . # . . . . .
    . . . . . . . . . . # . . . # . # # . . # #
    . . . . . . . . . . # . . . . . # . . . # #
    . # # . . . . . . . . # . . . # . . . . . .
    . . # . . . . . . . . . # # . . . . . . . .
    . # . . . . . . . . . . . . . . . . . . . .
    . # . . . . . . . . . . . . . . . . . . . .
    # # . . . . . . . . . . . . . . . . . . . .
  """

pufferFish :: Array Cell
pufferFish = C.fromAscii
  """
    . . . # . . . . . . . # . . .
    . . # # # . . . . . # # # . .
    . # # . . # . . . # . . # # .
    . . . # # # . . . # # # . . .
    . . . . . . . . . . . . . . .
    . . . . # . . . . . # . . . .
    . . # . . # . . . # . . # . .
    # . . . . . # . # . . . . . #
    # # . . . . # . # . . . . # #
    . . . . . . # . # . . . . . .
    . . . # . # . . . # . # . . .
    . . . . # . . . . . # . . . .
  """

pufferFishSpaceship :: Array Cell
pufferFishSpaceship = C.fromAscii
  """
    . . . . . . . # . . . . . . . # . . . . . . . . . . . . . . . . . . # . . . . . . . # . . . . . . . .
    . . . . . . # # # . . . . . # # # . . . . . . . . . . . . . . . . # # # . . . . . # # # . . . . . . .
    . . . . . # . . # # . . . # # . . # . . . . . . . . . . . . . . # # . # . . . . . # . # # . . . . . .
    . . . . . # . . . # . . . # . . . # . . . . . . . . . . . . . . . # # . # . . . # . # # . . . . . . .
    . . . . . . # # . # # . # # . # # . . . . . . . . . . . . . . # . # # . . . . . . . # # . # . . . . .
    . . . . . . # # . # . . . # . # # . . . . . . . . . . . . . # . # . . # . # . # . # . . # . # . . . .
    . . . . . . . . # . . . . . # . . . . . . . . . . . . . . . # . # . . . # # . # # . . . # . # . . . .
    . . . . . . . . . # # . # # . . . . . . . . . . . . . . . . . # # # . # . . . . . # . # # # . . . . .
    . . . . # # . . # . . . . . # . . # # . . . . . . . . . . . . . # # # . . . . . . . # # # . . . . . .
    . . . . # # . . # . . . . . # . . # # . . . . . . . . . . . . . # # . . . . . . . . . # # . . . . . .
    . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . # . . . . . . . . . . . # . . . . . .
    . . . . . . . . # . # . # . # . . . . . . . . . . . . . . . . # # . . . . . . . . . . . # # . . . . .
    . . . . . . . . # # . . . # # . . . . . . . . . . . . . . . . # # . . . . . . . . . . . # # . . . . .
    . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . .
    . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . # # . . . # # . . . . . . . . .
    . . . . . . . . . . . . . . . . . . . # . . . . . . . . . . # . . . . # # . . . # # . . . . . . . . .
    . . . # . . . . . . . . . . . . . . # # # . . . . . . . . # # # . . . . . . . . . . . . . . # . . . .
    . . # # # . . . # # . . . # . # . # # . # . . . . . . . # # . # . . . . . . . . . . . . . # # # . . .
    . # # . . # . . # # . . . . . . . . . # . . . . . . . . # # # . . . . . . . . . . . . . # # . # . . .
    . # # # # . # . . . . . . # . . . # . # . . . . . . . . # # # . . . . . . . . . . . . . # # . . . . .
    # # . . . . . # . . . . . . . # # . . # # . . . . . . . # # # # . . . . . . . . . . . . . . # # . . .
    . # . . . . . . . . . . . . . . . . # . . # . . . . . . # . . # . . . . . . . . . . . # . . # # . . .
    . # . # # # . . # . . . . # . # . . # # . . . . . . . # # . . . . . . . . . . . . . . # . . . . # . .
    . # . # . . . # # . . . . # . # . . # # . . . # . . . . # . # . . . . . . . . . . . # . . # . # . . .
    . # # . . . . . . # . . # . . . . . . . # . . # . . . . # # # . . . . . . . . . . # # . . . # # . . .
    # . . . . . # . # . . . . # . # . . . . # . # # . . . . . . . . . . . . . . . . # . . . . . . . . . .
    . # # . . # . . # . . . . # . . . . . . # . # # . . . . . . . . . . . . # . . . . # # . . . . . . . .
    . # # . . . # # . . . . . . . # # . . . # # . # # . . # # . . . . . . # # # # # # . . . . . . . . . .
    . . . . . . . . . . . . . . . . . . . . . . . . # . . . . # . . . . # . # . # . # . . . . . . . # # #
    . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . # . . . # . . # . . . . . . . . . # . . .
    . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . # . . . . # . . . . . . . . . . # . . . .
    . . . . . . . . . . . . . . . . . . . . . . . . . . . . . # . . . . . . . . . . . . . . . . . # . # .
  """
